import React from "react";

/**
 * Cabinet Depot brand logo.
 * Bundled locally in /public so it renders instantly on every page and inside
 * print iframes — no network fetch, no CORS, works offline.
 */
const LOGO_URL = `${process.env.PUBLIC_URL || ""}/cd-logo.png`;

export default function CDLogo({ className = "", alt = "Cabinet Depot" }) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      className={`object-contain ${className}`}
    />
  );
}

/**
 * Returns the logo URL suitable for embedding (e.g. inside print iframes).
 * Kept as a hook for backward compatibility with existing callers — but it's
 * now a pure string return since the asset is bundled, not fetched.
 */
export function useCabinetLogoDataUri() {
  return LOGO_URL;
}
